import type { FC, ReactNode } from 'react'

interface SectionHeadingProps {
    id: string
    eyebrow: string
    title: string
    children: ReactNode
}

export const SectionHeading: FC<SectionHeadingProps> = ({
    id,
    eyebrow,
    title,
    children
}): ReactNode => {
    return (
        <div className='max-w-2xl'>
            <p className='font-mono text-xs uppercase tracking-[0.28em] text-brand-red'>
                {eyebrow}
            </p>

            <h2 id={id} className='mt-4 text-balance font-heading text-3xl font-semibold tracking-tight text-foreground sm:text-4xl'>
                {title}
            </h2>

            <p className='mt-4 text-pretty text-base leading-relaxed text-muted-foreground sm:text-lg'>
                {children}
            </p>
        </div>
    )
}
